<template>
  <div class="account-info-page" v-loading="loading">
    <div class="title">账号信息</div>
    <div class="line-box">
      <div class="content-box">
        <div class="name">
          登陆账号：
        </div>
        <div class="content">
          {{ formData.enterpriseNo }}
        </div>
      </div>
      <div class="content-box">
        <div class="name">
          手机号码：
        </div>
        <div class="content">
          {{ formData.phone }}
        </div>
      </div>
      <div class="content-box">
        <div class="name">
          账户名称：
        </div>
        <div class="content">
          {{ formData.enterpriseName }}
        </div>
      </div>
      <div class="content-box" style="justify-content: space-between;align-items: center">
        <div style="display: flex">
          <div class="name">
            登陆密码：
          </div>
          <div class="hint">
            建议您定期更换密码，设置安全性高的密码可以使账户更安全
          </div>
        </div>
        <div class="change-passwd" @click="changePasswd">修改密码</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getEnterprisesInfo} from "@/api/mycenter";

export default {
  name: "accountInfo",
  beforeMount() {
    this.getEnterprisesInfo();
  },
  data() {
    return {
      loading: false,
      formData: {}
    }
  },
  methods: {
    getEnterprisesInfo() {
      this.loading = true;
      getEnterprisesInfo().then(result => {
        this.loading = false;
        if (result && result.code === "0") {
          this.formData = result.data;
        } else {
          this.$message({
            type: 'error',
            message: result.msg
          });
        }
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '出错了！'
        });
      })
    },
    changePasswd() {
      this.$router.push('/changePasswd');
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "@/assets/css/szui.scss";

.account-info-page {
  padding: 30px 24px 100px;
  background: #FFFFFF;
  border-radius: 8px;

  .title {
    line-height: 1;
    font-size: 16px;
    font-weight: bold;
    color: #262728;
  }

  .line-box {
    margin-top: 20px;

    .content-box {
      margin-top: 16px;
      line-height: 1;
      display: flex;
      font-size: 14px;
      font-weight: 400;
      color: #606366;

      .name {
        width: 84px;
        margin-right: 30px;
        flex-shrink: 0;
        font-size: 14px;
        font-weight: 400;
        color: #606366;
      }

      .content {
        font-size: 14px;
        font-weight: 400;
        color: #262728;
      }

      .hint {
        font-size: 14px;
        font-weight: 400;
        color: #909399;
      }

      .change-passwd {
        font-size: 15px;
        font-weight: 400;
        color: #005EB1;
        cursor: pointer;
      }
    }
  }


}
</style>